import React from "react";
import styled from "styled-components";
import {authorBackgroundColour, subduedTextColour} from "../../../../style/styleConsts";
import {Direction} from "../../idea/Direction";
import {ActivityTopRow} from "./ActivityTopRow";

const Container = styled.div`
    cursor: pointer;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 10px;
    padding-right: 10px;
    :hover {
        background-color: ${authorBackgroundColour};
    }
    :active {
        background-color: #f0ece9;
    }
`;

const SecondRow = styled.div`
    display: flex;
    align-items: center;
`;

const Bloomberg = styled.div`
    font-weight: bold;
    margin-left: 4px;
`;

const Comment = styled.div`
    margin-top: 3px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${subduedTextColour};
`;

function trimComment(action, comment) {
    if (action === "Autoclose") {
        return comment.substring(12);
    }
    return comment;
}

export const IdeaAction = ({action}) => {
    return <Container className="t-idea-action">
        <ActivityTopRow name={action.action} dateTime={action.dateTime}/>
        <SecondRow>
            <Direction direction={action.ideaType}/>
            <Bloomberg>{action.recommendation.bloomberg}</Bloomberg>
        </SecondRow>
        <Comment className="t-comment">{trimComment(action.action, action.comment)}</Comment>
    </Container>
};